module.exports = __webpack_public_path__ + "static/media/DEFI5-QUICK.46e7f97b.png";